import React, { useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FilterMatchMode, FilterOperator } from 'primereact/api'
import axios from 'axios'
import { Button } from 'primereact/button';
import { END_POINT } from '../config'
// import { ProductService } from './service/ProductService';

export default function Grid() {
  const [filters, setFilters] = useState({
    RequestName: { value: null, matchMode: FilterMatchMode.EQUALS },
    DLP: { value: null, matchMode: FilterMatchMode.EQUALS },
    SLP: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [requestdata, setReqData] = useState([])
  const [loading, setLoading] = useState(true); 

  const columns = [
    { field: 'inputfile', header: 'Input File' },
    { field: 'uploadedby', header: 'Uploaded By' },
    { field: 'uploadeddate', header: 'Uploaded Date' },
  ]

  const dlpSLPList = [
    {
      RequestName: '1',
      DLP: '2',
      SLP: '3',
    },
  ]

  useEffect(() => {
    axios.get(`${END_POINT}srs_pdf_getlist/`).then((res) => {
      console.log(res.data)
      console.log(dlpSLPList)
      setReqData(res.data)
      setLoading(false);
    })
  }, [])

  
  const downloadreport = async (foldername) => {
    console.log(foldername)
    const response = await downloadfile(foldername)

    const blod = await response.blob()

    const url = window.URL.createObjectURL(new Blob([blod]))

    const link = document.createElement('a')

    link.href = url

    link.setAttribute('download', 'result.zip')

    document.body.appendChild(link)

    link.click()

    link.remove()

    
  }

  const downloadfile = async (foldername) => {
    console.log(foldername)
    try {
      const response = await fetch(
        `${END_POINT}download/?foldername=` + foldername + '',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          //body: JSON.stringify(newTodo)
        },
      )

      console.log(response)

      return response
    } catch (err) {
      throw new Error('Failed download file')
    }
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="actions">
        <Button
          label={rowData.inputfile}
          className="p-button-warning p-mr-2"
          onClick={() => {
            downloadreport(rowData['outputfolder'])
          }}
        />
      </div>                               
    )
  }

  

  // globalFilterFields={['ReqestName', 'DLP', 'SLP']}
  return (
    <div className="card">
      <DataTable
        value={requestdata}
        paginator
        rows={10}
        dataKey="id"
        loading={loading}
        emptyMessage="No items found."
      >
        <Column
          body={actionBodyTemplate}
          header="Actions"
          style={{ minWidth: '12rem' }}
        />
        <Column
          field="uploadedby"
          header="Uploaded By"
          style={{ minWidth: '12rem' }}
        />
        <Column
          field="uploadeddate"
          header="Uploaded Date"
          style={{ minWidth: '12rem' }}
        />
      </DataTable>
     
    </div>
  )
}
